import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, rx: 8, fill: "currentColor", style: {
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M8 4.88672V8.99805", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 7.99896, cy: 11.0654, r: 0.733333, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgWarning;
